import { ListItem } from '@mui/material';

import { Link } from '@larvitu/shared/next/mui';

import type { LinkProps } from '@larvitu/shared/next/mui';
import type { FC, PropsWithChildren } from 'react';

export type LinkListItemProps = PropsWithChildren<LinkProps>;

/**
 * LinkListItem
 * @augments Link
 * @augments ListItem
 */
export const LinkListItem: FC<PropsWithChildren> = ({
  children = null,
  ...props
}) => (
  <Link style={{ textDecoration: 'none' }} {...props}>
    <ListItem sx={{ textDecoration: 'none' }} disablePadding>
      {children}
    </ListItem>
  </Link>
);
